import ReactGA4 from 'react-ga4';
import { AnalyticsGTM } from '@quicktools/shared-components/services/analytics-gtm';

import { VERSION, TOOL_NAME } from '../../configs';

import {
  CopyParams,
  CopywriterAnalyticsEventType,
  CtaClickParams,
  GenerateMoreParam,
  GenerateParam,
  PageClickParam,
  RephraseThisParam,
  ResultsActionParam,
  TabSelectParam,
  TextBoxClickParams,
  TextBoxTypeParams,
  TextGeneratedParam,
  ToolSelectParam,
} from './types';

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    dataLayer?: any[];
  }
}

class Analytics extends AnalyticsGTM {
  public pageOpen(pagePath: string, pageName?: string) {
    this.sendGaEvent(CopywriterAnalyticsEventType.PAGE_OPEN, {
      page_path: pagePath,
      non_interaction: true,
      page_name: pageName,
    });
    this.hjEvent(CopywriterAnalyticsEventType.PAGE_OPEN);
  }

  public ctaClick(params: CtaClickParams) {
    this.sendGaEvent(CopywriterAnalyticsEventType.CTA_CLICK, params);
    this.hjEvent(CopywriterAnalyticsEventType.CTA_CLICK);
  }

  public textBoxClick(params: TextBoxClickParams) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TEXT_BOX_CLICK, params);
    this.hjEvent(CopywriterAnalyticsEventType.TEXT_BOX_CLICK);
  }

  public tabSelect(params: TabSelectParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TAB_SELECT, params);
    this.hjEvent(CopywriterAnalyticsEventType.TAB_SELECT);
  }

  public resultsAction(params: ResultsActionParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.RESULT_ACTION, params);
    this.hjEvent(CopywriterAnalyticsEventType.RESULT_ACTION);
  }

  public pageClick(params: PageClickParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.PAGE_CLICK, params);
    this.hjEvent(CopywriterAnalyticsEventType.PAGE_CLICK);
  }

  public generate(params: GenerateParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.GENERATE, params);
    this.hjEvent(CopywriterAnalyticsEventType.GENERATE);
  }

  public textGenerated(params: TextGeneratedParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TEXT_GENERATED, params);
    this.hjEvent(CopywriterAnalyticsEventType.TEXT_GENERATED);
  }

  public textboxType(params: TextBoxTypeParams) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TEXT_BOX_TYPE, params);
    this.hjEvent(CopywriterAnalyticsEventType.TEXT_BOX_TYPE);
  }

  public generateMore(params: GenerateMoreParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.GENERATE_MORE, params);
    this.hjEvent(CopywriterAnalyticsEventType.GENERATE_MORE);
  }

  public pillarToolSelect(params: ToolSelectParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TOOL_SELECT, params);
    this.hjEvent(CopywriterAnalyticsEventType.TOOL_SELECT);
  }

  public copy(params: CopyParams) {
    this.sendGaEvent(CopywriterAnalyticsEventType.TEXT_COPY_CONVERSATION, params);
    this.hjEvent(CopywriterAnalyticsEventType.TEXT_COPY_CONVERSATION);
  }

  public rephraseThis(params: RephraseThisParam) {
    this.sendGaEvent(CopywriterAnalyticsEventType.REPHRASE_THIS, params);
    this.hjEvent(CopywriterAnalyticsEventType.REPHRASE_THIS);
  }
}

export default new Analytics(
  {
    VERSION,
    TOOL_NAME,
  },
  ReactGA4,
);
